import BaseCtrl from 'edge/platform/base/BaseCtrl';
import Submission from 'edge/quoteandbind/common/models/Submission';
import flowStepToFieldsMappings from 'edge/quoteandbind/common/config/flowStepToFieldsMappings.json5';

import moment from 'moment';
import MockUpUtil from 'gw-portals-util-js/MockUpUtil';


const mockUpUtil = new MockUpUtil();
const fn = function (
    $scope, $state, $stateParams, LoadSaveService, ModalService, wizardFlowService,
    qnbCompositeFlowDefn, ViewModelService, viewModelContext, returnStateFn,
    errorStateFn, effectiveDateStateFn, CampaignDataService, QuoteJumpToStepService
) {
    const ctrl = Object.create(BaseCtrl);
    const parentWizardState = 'baseTransactionWizard';

    ctrl.init = function () {
        const stepToStateMapping = {
            returnHome: model => returnStateFn(model),
            confirmation: (model) => ['qnbconfirmation', {
                quoteSummary: model.value,
                returnStateInfo: returnStateFn(model.value)
            }],
            knockoutpage: (model) => ['knockoutpage', {
                uwIssues: (model) ? model.errorsAndWarnings.underwritingIssues.value
                    .filter(uwIssue => uwIssue.currentBlockingPoint === 'Rejected') : null,
                returnStateInfo: returnStateFn(model.value)
            }],
            error: model => errorStateFn(model),
            effectiveDate: model => effectiveDateStateFn(model)
        };
        const quoteSnapshotListener = (model, fromStep, toStep) => {
            const {value: submission} = model;
            QuoteJumpToStepService.addSnapshotAndHighestIndex(submission, fromStep, toStep);
        };
        const flowFactory = wizardFlowService(qnbCompositeFlowDefn, parentWizardState, stepToStateMapping, [], flowStepToFieldsMappings);

        if ($stateParams.quoteID) { // resume draft submission
            const submissionLoadPromise = LoadSaveService.retrieveSubmission($stateParams);
            $scope.submissionLoadPromise = submissionLoadPromise;

            submissionLoadPromise.then(submissionData => {
                const contactPhoneMockupData = mockUpUtil.getMockData('bindData.contactPhone');
                if ($stateParams.shouldUpdateEffectiveDate && moment(submissionData.baseData.periodStartDate).isBefore(moment(), 'day')) {
                    const now = new Date();
                    submissionData.baseData.periodStartDate = {
                        year: now.getFullYear(),
                        month: now.getMonth(),
                        day: now.getDate()
                    };
                }

                if (submissionData.bindData && !submissionData.bindData.contactPhone) {
                    submissionData.bindData.contactPhone = contactPhoneMockupData;
                }
                const submission = new Submission(submissionData);
                const submissionVM = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', viewModelContext);
                const flowModel = flowFactory.resume(submissionVM, $stateParams);
                flowModel.addStepChangeListener(quoteSnapshotListener);
                flowModel.alternativeJumpToStepCheck = QuoteJumpToStepService.checkIfTransitionAllowed;
            }).catch(() => {
                const errorPromise = ModalService.showError(
                    'quoteandbind.controllers.QuoteEntryCtrl.Error retrieving submission',
                    'quoteandbind.controllers.QuoteEntryCtrl.Sorry, but we can\'t seem to locate a quote with that number and that ZIP code. Please try again.'
                ).result;
                errorPromise.then(() => {
                    const returnData = returnStateFn({
                        quoteID: $stateParams.quoteID
                    });
                    // return the home page
                    $state.go(returnData[0], returnData[1]);
                });
            });
        } else {
            const submission = new Submission($stateParams.productCode);

            if ($stateParams.account) {
                submission.baseData.accountHolder = $stateParams.account;
                submission.baseData.accountNumber = $stateParams.account.accountNumber;
                submission.baseData.policyAddress = $stateParams.account.primaryAddress;
            }

            const campaignData = CampaignDataService;
            if (campaignData && campaignData.utm_campaign) {
                submission.baseData.trackingCode = [{
                    codeValue: campaignData.utm_campaign,
                    codeName: 'utm_campaign'
                }];
            }

            const submissionModel = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', viewModelContext);

            const flowModel = flowFactory.start(submissionModel, $stateParams);
            flowModel.addStepChangeListener(quoteSnapshotListener);
            flowModel.alternativeJumpToStepCheck = QuoteJumpToStepService.checkIfTransitionAllowed;
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$stateParams', 'qnb.LoadSaveService', 'ModalService', 'WizardFlowService',
    'qnb.CompositeFlowDefn', 'ViewModelService', 'qnb.ViewModelCtx', 'qnb.returnStateFn',
    'qnb.errorStateFn', 'qnb.effectiveDateStateFn', 'CampaignDataService', 'QuoteJumpToStepService'
];

export default fn;
